import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { eq } from 'ember-truth-helpers';
import { getOwner } from '@ember/owner';
import {
  HdsFormSelectField,
  HdsIcon,
} from '@hashicorp/design-system-components/components';
import type ConfigService from '../services/config.ts';
import type MirageScenarioService from 'api/services/mirage-scenario';

interface GeoDevToolsSignature {
  // eslint-disable-next-line @typescript-eslint/ban-types
  Args: {};
}

export default class GeoDevTools extends Component<GeoDevToolsSignature> {
  geos = ['us', 'eu'];

  get mirage() {
    return getOwner(this)?.lookup(
      'service:mirage-scenario'
    ) as MirageScenarioService;
  }

  get config() {
    return getOwner(this)?.lookup('service:config') as ConfigService;
  }

  get seletedGeo() {
    return this.config?.app?.deployGeo || 'us';
  }

  // @ts-expect-error: missing types
  setGeo = (event) => {
    let configCopy = structuredClone(this.config?.app);
    if (configCopy) {
      configCopy.deployGeo = event.target.value;
      if (this.mirage) {
        this.mirage.geo = configCopy.deployGeo;
      }
      if (this.config) {
        this.config.app = configCopy;
      }
    }
  };

  <template>
    {{! template-lint-disable no-bare-strings  }}
    {{! this won't be shown in any non-local env so we don't need to bother with i18n }}
    <HdsFormSelectField @id="select-geo" {{on "change" this.setGeo}} as |F|>
      <F.Label>
        <HdsIcon @name="globe" />
        Active geo:
      </F.Label>
      <F.Options>
        {{#each this.geos as |geo|}}
          <option name="geo" value={{geo}} selected={{eq geo this.seletedGeo}}>
            {{geo}}
          </option>
        {{/each}}
      </F.Options>
    </HdsFormSelectField>
  </template>
}
